import Vue from 'vue';

Vue.filter('capFirst', (value) => {
    if (!value) {
        return '';
    }

    const stringValue = value.toString();

    return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
});

Vue.filter('capAll', (value) => {
    if (!value) {
        return '';
    }

    const stringValue = value.toString();

    return stringValue.replace(/[^\s]+/g, word => word.replace(/^./, first => first.toUpperCase()));
});

Vue.filter('lowercase', value => value.toLowerCase());

Vue.filter('uppercase', value => value.toUpperCase());

Vue.filter('subString', (value, from, to) => {
    if (!value) {
        return '';
    }

    return value.substr(from, to);
});

Vue.filter('limitString', (value, limit, append = '...') => {
    if (!value) {
        return '';
    }

    if (value.length <= limit) {
        return value;
    }

    return value.substr(0, limit) + append;
});

Vue.filter('prettyName', (value, limit = 20) => {
    if (!value) {
        return '';
    }

    if (value.length < limit) {
        return value;
    }

    // TODO:  if name + surname is less than limit, return that.

    return value.split(' ')[0];
});



// WEBPACK FOOTER //
// ./src/global/filters/strings.js